import React from 'react';
import { Translate, withLocalize } from 'react-localize-redux';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import Lambda from '../../../aws/lambda';

const styles = {
  card: {
    maxWidth: '90vw',
  },
};

class CustomizationContacts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      processing: false,
      IdPaeseDT: '',
      IdCodiceDT: '',
      ProgressivoInvio: '',
      FormatoTrasmissione: '',
      CodiceDestinatario: '',
      TelefonoDT: '',
      EmailDT: '',
      IdPaeseCP: '',
      IdCodiceCP: '',
      CodiceFiscale: '',
      Denominazione: '',
      RegimeFiscale: '',
      Indirizzo: '',
      CAP: '',
      Comune: '',
      Provincia: '',
      Nazione: '',
      Ufficio: '',
      NumeroREA: '',
      CapitaleSociale: '',
      SocioUnico: '',
      StatoLiquidazione: '',
      TelefonoCP: '',
      EmailCP: '',
      TipoDocumento: '',
      // Numero: '',
      Causale: '',
      Descrizione: '',
      EsigibilitaIVA: '',
    };
    this.onChange = this.onChange.bind(this);
    this.reset = this.reset.bind(this);
    this.submit = this.submit.bind(this);
    this.secureSetState = this.secureSetState.bind(this);
    this._isMounted = false;
  }

  get isMounted() {
    return this._isMounted;
  }

  set isMounted(val) {
    this._isMounted = val;
  }

  secureSetState(state, callback) {
    if (!this.isMounted) {
      return;
    }
    this.setState(state, callback);
  }

  onChange(e) {
    if (this.state.processing) {
      return;
    }
    let { name, value } = e.target;
    this.secureSetState({ [name]: value });
  }

  reset() {
    if (this.state.processing) {
      return;
    }
    this.secureSetState({
      IdPaeseDT: this.props.invoicesData.IdPaeseDT,
      IdCodiceDT: this.props.invoicesData.IdCodiceDT,
      ProgressivoInvio: this.props.invoicesData.ProgressivoInvio,
      FormatoTrasmissione: this.props.invoicesData.FormatoTrasmissione,
      CodiceDestinatario: this.props.invoicesData.CodiceDestinatario,
      TelefonoDT: this.props.invoicesData.TelefonoDT,
      EmailDT: this.props.invoicesData.EmailDT,
      IdPaeseCP: this.props.invoicesData.IdPaeseCP,
      IdCodiceCP: this.props.invoicesData.IdCodiceCP,
      CodiceFiscale: this.props.invoicesData.CodiceFiscale,
      Denominazione: this.props.invoicesData.Denominazione,
      RegimeFiscale: this.props.invoicesData.RegimeFiscale,
      Indirizzo: this.props.invoicesData.Indirizzo,
      CAP: this.props.invoicesData.CAP,
      Comune: this.props.invoicesData.Comune,
      Provincia: this.props.invoicesData.Provincia,
      Nazione: this.props.invoicesData.Nazione,
      Ufficio: this.props.invoicesData.Ufficio,
      NumeroREA: this.props.invoicesData.NumeroREA,
      CapitaleSociale: this.props.invoicesData.CapitaleSociale,
      SocioUnico: this.props.invoicesData.SocioUnico,
      StatoLiquidazione: this.props.invoicesData.StatoLiquidazione,
      TelefonoCP: this.props.invoicesData.TelefonoCP,
      EmailCP: this.props.invoicesData.EmailCP,
      TipoDocumento: this.props.invoicesData.TipoDocumento,
      // Numero: this.props.invoicesData.Numero,
      Causale: this.props.invoicesData.Causale,
      Descrizione: this.props.invoicesData.Descrizione,
      EsigibilitaIVA: this.props.invoicesData.EsigibilitaIVA,
    });
  }

  submit() {
    if (this.state.processing) {
      return;
    }
    this.secureSetState({ processing: true }, async () => {
      let {
        IdPaeseDT,
        IdCodiceDT,
        ProgressivoInvio,
        FormatoTrasmissione,
        CodiceDestinatario,
        TelefonoDT,
        EmailDT,
        IdPaeseCP,
        IdCodiceCP,
        CodiceFiscale,
        Denominazione,
        RegimeFiscale,
        Indirizzo,
        CAP,
        Comune,
        Provincia,
        Nazione,
        Ufficio,
        NumeroREA,
        CapitaleSociale,
        SocioUnico,
        StatoLiquidazione,
        TelefonoCP,
        EmailCP,
        TipoDocumento,
        // Numero,
        Causale,
        Descrizione,
        EsigibilitaIVA,
      } = this.state;
      IdPaeseDT = IdPaeseDT.trim();
      IdCodiceDT = IdCodiceDT.trim();
      ProgressivoInvio = ProgressivoInvio.trim();
      FormatoTrasmissione = FormatoTrasmissione.trim();
      CodiceDestinatario = CodiceDestinatario.trim();
      TelefonoDT = TelefonoDT.trim();
      EmailDT = EmailDT.trim();
      IdPaeseCP = IdPaeseCP.trim();
      IdCodiceCP = IdCodiceCP.trim();
      CodiceFiscale = CodiceFiscale.trim();
      Denominazione = Denominazione.trim();
      RegimeFiscale = RegimeFiscale.trim();
      Indirizzo = Indirizzo.trim();
      CAP = CAP.trim();
      Comune = Comune.trim();
      Provincia = Provincia.trim();
      Nazione = Nazione.trim();
      Ufficio = Ufficio.trim();
      NumeroREA = NumeroREA.trim();
      CapitaleSociale = CapitaleSociale.trim();
      SocioUnico = SocioUnico.trim();
      StatoLiquidazione = StatoLiquidazione.trim();
      TelefonoCP = TelefonoCP.trim();
      EmailCP = EmailCP.trim();
      TipoDocumento = TipoDocumento.trim();
      // Numero = Numero.trim();
      Causale = Causale.trim();
      Descrizione = Descrizione.trim();
      EsigibilitaIVA = EsigibilitaIVA.trim();
      let invoicesData = {};
      if (IdPaeseDT.length > 0) {
        invoicesData.IdPaeseDT = IdPaeseDT;
      }
      if (IdCodiceDT.length > 0) {
        invoicesData.IdCodiceDT = IdCodiceDT;
      }
      if (ProgressivoInvio.length > 0) {
        invoicesData.ProgressivoInvio = ProgressivoInvio;
      }
      if (FormatoTrasmissione.length > 0) {
        invoicesData.FormatoTrasmissione = FormatoTrasmissione;
      }
      if (CodiceDestinatario.length > 0) {
        invoicesData.CodiceDestinatario = CodiceDestinatario;
      }
      if (TelefonoDT.length > 0) {
        invoicesData.TelefonoDT = TelefonoDT;
      }
      if (EmailDT.length > 0) {
        invoicesData.EmailDT = EmailDT;
      }
      if (IdPaeseCP.length > 0) {
        invoicesData.IdPaeseCP = IdPaeseCP;
      }
      if (IdCodiceCP.length > 0) {
        invoicesData.IdCodiceCP = IdCodiceCP;
      }
      if (CodiceFiscale.length > 0) {
        invoicesData.CodiceFiscale = CodiceFiscale;
      }
      if (Denominazione.length > 0) {
        invoicesData.Denominazione = Denominazione;
      }
      if (RegimeFiscale.length > 0) {
        invoicesData.RegimeFiscale = RegimeFiscale;
      }
      if (Indirizzo.length > 0) {
        invoicesData.Indirizzo = Indirizzo;
      }
      if (CAP.length > 0) {
        invoicesData.CAP = CAP;
      }
      if (Comune.length > 0) {
        invoicesData.Comune = Comune;
      }
      if (Provincia.length > 0) {
        invoicesData.Provincia = Provincia;
      }
      if (Nazione.length > 0) {
        invoicesData.Nazione = Nazione;
      }
      if (Ufficio.length > 0) {
        invoicesData.Ufficio = Ufficio;
      }
      if (NumeroREA.length > 0) {
        invoicesData.NumeroREA = NumeroREA;
      }
      if (CapitaleSociale.length > 0) {
        invoicesData.CapitaleSociale = CapitaleSociale;
      }
      if (SocioUnico.length > 0) {
        invoicesData.SocioUnico = SocioUnico;
      }
      if (StatoLiquidazione.length > 0) {
        invoicesData.StatoLiquidazione = StatoLiquidazione;
      }
      if (TelefonoCP.length > 0) {
        invoicesData.TelefonoCP = TelefonoCP;
      }
      if (EmailCP.length > 0) {
        invoicesData.EmailCP = EmailCP;
      }
      if (TipoDocumento.length > 0) {
        invoicesData.TipoDocumento = TipoDocumento;
      }
      if (Causale.length > 0) {
        invoicesData.Causale = Causale;
      }
      if (Descrizione.length > 0) {
        invoicesData.Descrizione = Descrizione;
      }
      if (EsigibilitaIVA.length > 0) {
        invoicesData.EsigibilitaIVA = EsigibilitaIVA;
      }

      try {
        let params = {
          action: 'edit',
          user: this.props.user.id,
          client: {
            id: this.props.user.client,
            invoicesData: invoicesData,
            // invoicesNumber: Numero.length > 0 ? Numero : '1/EV',
          },
        };
        await Lambda.invoke('ManageClient', params);
        this.secureSetState({ processing: false }, () => {
          this.props.showSnackbar('success');
          this.props.update('invoicesData', {
            IdPaeseDT,
            IdCodiceDT,
            ProgressivoInvio,
            FormatoTrasmissione,
            CodiceDestinatario,
            TelefonoDT,
            EmailDT,
            IdPaeseCP,
            IdCodiceCP,
            CodiceFiscale,
            Denominazione,
            RegimeFiscale,
            Indirizzo,
            CAP,
            Comune,
            Provincia,
            Nazione,
            Ufficio,
            NumeroREA,
            CapitaleSociale,
            SocioUnico,
            StatoLiquidazione,
            TelefonoCP,
            EmailCP,
            TipoDocumento,
            // Numero,
            Causale,
            Descrizione,
            EsigibilitaIVA,
          });
        });
      } catch (err) {
        console.error(err);
        this.secureSetState({ processing: false }, () => {
          this.props.showSnackbar('contactsError');
        });
      }
    });
  }

  componentDidMount() {
    this.isMounted = true;
  }

  componentDidUpdate(prevProps) {
    let state = {};
    if (prevProps.invoicesData.IdPaeseDT !== this.props.invoicesData.IdPaeseDT) {
      state.IdPaeseDT = this.props.invoicesData.IdPaeseDT || '';
    }
    if (prevProps.invoicesData.IdCodiceDT !== this.props.invoicesData.IdCodiceDT) {
      state.IdCodiceDT = this.props.invoicesData.IdCodiceDT || '';
    }
    if (prevProps.invoicesData.ProgressivoInvio !== this.props.invoicesData.ProgressivoInvio) {
      state.ProgressivoInvio = this.props.invoicesData.ProgressivoInvio || '';
    }
    if (prevProps.invoicesData.FormatoTrasmissione !== this.props.invoicesData.FormatoTrasmissione) {
      state.FormatoTrasmissione = this.props.invoicesData.FormatoTrasmissione || '';
    }
    if (prevProps.invoicesData.CodiceDestinatario !== this.props.invoicesData.CodiceDestinatario) {
      state.CodiceDestinatario = this.props.invoicesData.CodiceDestinatario || '';
    }
    if (prevProps.invoicesData.TelefonoDT !== this.props.invoicesData.TelefonoDT) {
      state.TelefonoDT = this.props.invoicesData.TelefonoDT || '';
    }
    if (prevProps.invoicesData.EmailDT !== this.props.invoicesData.EmailDT) {
      state.EmailDT = this.props.invoicesData.EmailDT || '';
    }
    if (prevProps.invoicesData.IdPaeseCP !== this.props.invoicesData.IdPaeseCP) {
      state.IdPaeseCP = this.props.invoicesData.IdPaeseCP || '';
    }
    if (prevProps.invoicesData.IdCodiceCP !== this.props.invoicesData.IdCodiceCP) {
      state.IdCodiceCP = this.props.invoicesData.IdCodiceCP || '';
    }
    if (prevProps.invoicesData.CodiceFiscale !== this.props.invoicesData.CodiceFiscale) {
      state.CodiceFiscale = this.props.invoicesData.CodiceFiscale || '';
    }
    if (prevProps.invoicesData.Denominazione !== this.props.invoicesData.Denominazione) {
      state.Denominazione = this.props.invoicesData.Denominazione || '';
    }
    if (prevProps.invoicesData.RegimeFiscale !== this.props.invoicesData.RegimeFiscale) {
      state.RegimeFiscale = this.props.invoicesData.RegimeFiscale || '';
    }
    if (prevProps.invoicesData.Indirizzo !== this.props.invoicesData.Indirizzo) {
      state.Indirizzo = this.props.invoicesData.Indirizzo || '';
    }
    if (prevProps.invoicesData.CAP !== this.props.invoicesData.CAP) {
      state.CAP = this.props.invoicesData.CAP || '';
    }
    if (prevProps.invoicesData.Comune !== this.props.invoicesData.Comune) {
      state.Comune = this.props.invoicesData.Comune || '';
    }
    if (prevProps.invoicesData.Provincia !== this.props.invoicesData.Provincia) {
      state.Provincia = this.props.invoicesData.Provincia || '';
    }
    if (prevProps.invoicesData.Nazione !== this.props.invoicesData.Nazione) {
      state.Nazione = this.props.invoicesData.Nazione || '';
    }
    if (prevProps.invoicesData.Ufficio !== this.props.invoicesData.Ufficio) {
      state.Ufficio = this.props.invoicesData.Ufficio || '';
    }
    if (prevProps.invoicesData.NumeroREA !== this.props.invoicesData.NumeroREA) {
      state.NumeroREA = this.props.invoicesData.NumeroREA || '';
    }
    if (prevProps.invoicesData.CapitaleSociale !== this.props.invoicesData.CapitaleSociale) {
      state.CapitaleSociale = this.props.invoicesData.CapitaleSociale || '';
    }
    if (prevProps.invoicesData.SocioUnico !== this.props.invoicesData.SocioUnico) {
      state.SocioUnico = this.props.invoicesData.SocioUnico || '';
    }
    if (prevProps.invoicesData.StatoLiquidazione !== this.props.invoicesData.StatoLiquidazione) {
      state.StatoLiquidazione = this.props.invoicesData.StatoLiquidazione || '';
    }
    if (prevProps.invoicesData.TelefonoCP !== this.props.invoicesData.TelefonoCP) {
      state.TelefonoCP = this.props.invoicesData.TelefonoCP || '';
    }
    if (prevProps.invoicesData.EmailCP !== this.props.invoicesData.EmailCP) {
      state.EmailCP = this.props.invoicesData.EmailCP || '';
    }
    if (prevProps.invoicesData.TipoDocumento !== this.props.invoicesData.TipoDocumento) {
      state.TipoDocumento = this.props.invoicesData.TipoDocumento || '';
    }
    // if (prevProps.invoicesNumber !== this.propsinvoicesNumber) {
    //   state.Numero = this.props.invoicesNumber || '';
    // }
    if (prevProps.invoicesData.Causale !== this.props.invoicesData.Causale) {
      state.Causale = this.props.invoicesData.Causale || '';
    }
    if (prevProps.invoicesData.Descrizione !== this.props.invoicesData.Descrizione) {
      state.Descrizione = this.props.invoicesData.Descrizione || '';
    }
    if (prevProps.invoicesData.EsigibilitaIVA !== this.props.invoicesData.EsigibilitaIVA) {
      state.EsigibilitaIVA = this.props.invoicesData.EsigibilitaIVA || '';
    }

    if (Object.keys(state).length > 0) {
      this.secureSetState(state);
    }
  }

  componentWillUnmount() {
    this.isMounted = false;
  }

  render() {
    return (
      <Card className={this.props.classes.card}>
        <CardHeader title={<Translate id='customization.invoicesData.title' />} subheader={<Translate id='customization.invoicesData.subheader' />} />
        <CardContent>
          <Grid container direction='column' justifyContent='flex-start' alignItems='stretch'>
            <TextField
              label={this.props.translate('customization.invoicesData.IdPaeseDT')}
              name='IdPaeseDT'
              value={this.state.IdPaeseDT}
              onChange={this.onChange}
            />
            <TextField
              label={this.props.translate('customization.invoicesData.IdCodiceDT')}
              name='IdCodiceDT'
              value={this.state.IdCodiceDT}
              onChange={this.onChange}
            />
            {/* {<TextField
              label={this.props.translate('customization.invoicesData.ProgressivoInvio')}
              name='ProgressivoInvio'
              value={this.state.ProgressivoInvio}
              onChange={this.onChange}
            />} */}
            <TextField
              label={this.props.translate('customization.invoicesData.FormatoTrasmissione')}
              name='FormatoTrasmissione'
              value={this.state.FormatoTrasmissione}
              onChange={this.onChange}
            />
            {/* {<TextField
              label={this.props.translate('customization.invoicesData.CodiceDestinatario')}
              name='CodiceDestinatario'
              value={this.state.CodiceDestinatario}
              onChange={this.onChange}
            />} */}
            <TextField
              label={this.props.translate('customization.invoicesData.TelefonoDT')}
              name='TelefonoDT'
              value={this.state.TelefonoDT}
              onChange={this.onChange}
            />
            <TextField label={this.props.translate('customization.invoicesData.EmailDT')} name='EmailDT' value={this.state.EmailDT} onChange={this.onChange} />
            <TextField
              label={this.props.translate('customization.invoicesData.IdPaeseCP')}
              name='IdPaeseCP'
              value={this.state.IdPaeseCP}
              onChange={this.onChange}
            />
            <TextField
              label={this.props.translate('customization.invoicesData.IdCodiceCP')}
              name='IdCodiceCP'
              value={this.state.IdCodiceCP}
              onChange={this.onChange}
            />
            <TextField
              label={this.props.translate('customization.invoicesData.CodiceFiscale')}
              name='CodiceFiscale'
              value={this.state.CodiceFiscale}
              onChange={this.onChange}
            />
            <TextField
              label={this.props.translate('customization.invoicesData.Denominazione')}
              name='Denominazione'
              value={this.state.Denominazione}
              onChange={this.onChange}
            />
            <TextField
              label={this.props.translate('customization.invoicesData.RegimeFiscale')}
              name='RegimeFiscale'
              value={this.state.RegimeFiscale}
              onChange={this.onChange}
            />
            <TextField
              label={this.props.translate('customization.invoicesData.Indirizzo')}
              name='Indirizzo'
              value={this.state.Indirizzo}
              onChange={this.onChange}
            />
            <TextField label={this.props.translate('customization.invoicesData.CAP')} name='CAP' value={this.state.CAP} onChange={this.onChange} />
            <TextField label={this.props.translate('customization.invoicesData.Comune')} name='Comune' value={this.state.Comune} onChange={this.onChange} />
            <TextField
              label={this.props.translate('customization.invoicesData.Provincia')}
              name='Provincia'
              value={this.state.Provincia}
              onChange={this.onChange}
            />
            <TextField label={this.props.translate('customization.invoicesData.Nazione')} name='Nazione' value={this.state.Nazione} onChange={this.onChange} />
            <TextField label={this.props.translate('customization.invoicesData.Ufficio')} name='Ufficio' value={this.state.Ufficio} onChange={this.onChange} />
            <TextField
              label={this.props.translate('customization.invoicesData.NumeroREA')}
              name='NumeroREA'
              value={this.state.NumeroREA}
              onChange={this.onChange}
            />
            <TextField
              label={this.props.translate('customization.invoicesData.CapitaleSociale')}
              name='CapitaleSociale'
              value={this.state.CapitaleSociale}
              onChange={this.onChange}
            />
            <TextField
              label={this.props.translate('customization.invoicesData.SocioUnico')}
              name='SocioUnico'
              value={this.state.SocioUnico}
              onChange={this.onChange}
            />
            <TextField
              label={this.props.translate('customization.invoicesData.StatoLiquidazione')}
              name='StatoLiquidazione'
              value={this.state.StatoLiquidazione}
              onChange={this.onChange}
            />
            <TextField
              label={this.props.translate('customization.invoicesData.TelefonoCP')}
              name='TelefonoCP'
              value={this.state.TelefonoCP}
              onChange={this.onChange}
            />
            <TextField label={this.props.translate('customization.invoicesData.EmailCP')} name='EmailCP' value={this.state.EmailCP} onChange={this.onChange} />
            <TextField
              label={this.props.translate('customization.invoicesData.TipoDocumento')}
              name='TipoDocumento'
              value={this.state.TipoDocumento}
              onChange={this.onChange}
            />
            {/* {<TextField label={this.props.translate('customization.invoicesData.Numero')} name='Numero' value={this.state.Numero} onChange={this.onChange} />} */}
            <TextField label={this.props.translate('customization.invoicesData.Causale')} name='Causale' value={this.state.Causale} onChange={this.onChange} />
            <TextField
              label={this.props.translate('customization.invoicesData.Descrizione')}
              name='Descrizione'
              value={this.state.Descrizione}
              onChange={this.onChange}
            />
            <TextField
              label={this.props.translate('customization.invoicesData.EsigibilitaIVA')}
              name='EsigibilitaIVA'
              value={this.state.EsigibilitaIVA}
              onChange={this.onChange}
            />
          </Grid>
        </CardContent>
        <CardActions>
          <Grid container direction='row' alignItems='center' justifyContent='flex-end'>
            <Button size='small' onClick={this.reset}>
              <Translate id='customization.reset' />
            </Button>
            <Button size='small' color='primary' onClick={this.submit}>
              <Translate id='customization.confirm' />
            </Button>
          </Grid>
        </CardActions>
      </Card>
    );
  }
}

export default withStyles(styles)(withLocalize(CustomizationContacts));
